module.exports = __webpack_public_path__ + "static/media/login_header.f6e030bb.png";